import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
declare var clevertap: any;

@Injectable({
  providedIn: 'root'
})
export class CleverTapEventsService {
  eventsSubscription:Subscription;
  videoCount: any;
  imageCount: any;
  otherCount: any;
  audioCount: any;
  isFoderexist: boolean = false;
  experienceNowModalLocation:any
  constructor() {
  }

  setClearTapProfilePush(uerId) { // push user clevertap profile
    clevertap.onUserLogin.push({
      "Site": {
        "Identity": uerId, 
        "MSG-email": false, // Disable email notifications
        "MSG-push": true, // Enable push notifications
        "MSG-sms": true // Enable sms notifications
      }
    });
  } 
  async repoFileViewed(obj,place){
    let location = await this.fetchLocation(place)
    if(location == 'REPO' || location == 'SHAREDFILES'){
      clevertap.event.push(EventsNames.fileView, {
        "TYPE": obj.mimeType,
        "PLACE": location
      });
    }else {
      if(window.location.href.indexOf("/albums") > -1) {
        let isAlbumOwner = await this.isAlbumOwner(obj.owner.ownerUserId,obj.createdBy)
        clevertap.event.push(EventsNames.fileView, {
          "TYPE": obj.mimeType,
          "PLACE": location,
          "VIEWER": isAlbumOwner
        });
      }
    }
  }
  async sharLinkGenearted(obj,place){
    await this.isFolderExist(obj)
    let location = await this.fetchLocation(place)
    if(!this.isFoderexist || this.isFoderexist == undefined){
      await this.getFileCount(obj);
      if(location == 'REPO'){
        clevertap.event.push(EventsNames.shareLink, {
          "NOOFFILES": obj.length,
          "PLACE": location,
          "VIDEOCOUNT": this.videoCount.length,
          "AUDIOCOUNT": this.audioCount.length,
          "IMAGECOUNT": this.imageCount.length,
          "OTHERCOUNT": this.otherCount.length
        });
      }
    }else{
      if(location == 'REPO'){
        clevertap.event.push(EventsNames.shareLink, {
          "NOOFFILES": obj.length,
          "PLACE": location,
        });
      }
      
    }
  }
  async sharLinkGeneartedAlbums(obj,inviter){
    await this.isFolderExist(obj)
    if(!this.isFoderexist || this.isFoderexist == undefined){
      await this.getFileCount(obj);
        clevertap.event.push(EventsNames.shareLink, {
          "NOOFFILES": obj.length,
          "PLACE": 'ALBUMS',
          "INVITER": inviter,
          "VIDEOCOUNT": this.videoCount.length,
          "AUDIOCOUNT": this.audioCount.length,
          "IMAGECOUNT": this.imageCount.length,
          "OTHERCOUNT": this.otherCount.length
        });
    }
  }
  isFolderExist(obj){
    obj.find((item)=> {
       if(item.objectType == 'FR'){
         this.isFoderexist = true
       }
    });
  }
  userLogout(){
    clevertap.event.push(EventsNames.logout, {});
  }
  async mandatoryEmailModalViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.mandatoryEmailVeri
    });
  }
  async notMandatoryEmailModalViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.notMandatoryEmailVeri
    });
  }
  async phoneModalViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.phoneVeri
    });
  }
  async backupPhoneModalViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.backupVeri
    });
  }
  emailBannerClicked(){
    clevertap.event.push(EventsNames.bannerClicked, {
      "Name": ScreenNames.mandatoryEmailVeri
    });
  }
  emailVerifyOtpReq(medium){
    clevertap.event.push(EventsNames.emailVerifyOtp, {
      "RECEIVING_MEDIUM": medium,
      "ERROR": "SUCCESS"
    });
  }
  emailVerifyOtpError(errrorObj){
    if(errrorObj){
      clevertap.event.push(EventsNames.emailVerifyOtp, {
        "ERROR": errrorObj.code + "," + "NA" + "," + errrorObj.error
      });
    }
  }
  emailVerifySuccess(src){
    clevertap.event.push(EventsNames.emailVeri, {
      "ERROR": "SUCCESS",
      "SOURCE": src
    });
  }
  emailVerifyError(errrorObj,src){
    if(errrorObj){
      clevertap.event.push(EventsNames.emailVeri, {
        "ERROR": errrorObj.code + "," + "NA" + "," + errrorObj.error,
        "SOURCE": src
      });
    }
  }
  emailVerifyAlreadyHavOtpClicked(){
    clevertap.event.push(EventsNames.emailVerifyAlreadyHaveOtp, {});
  }
  cretaeFolder(folderName){
    clevertap.event.push(EventsNames.createFolder, {
      "FOLDERNAME": folderName
    });
  }
  mobileVerifySuccess(src){
    clevertap.event.push(EventsNames.mobileVeri, {
      "ERROR": "SUCCESS",
      "SOURCE": src
    });
  }
  mobileVerifyError(errrorObj,src){
    if(errrorObj){
      clevertap.event.push(EventsNames.mobileVeri, {
        "ERROR": errrorObj.code + "," + "NA" + "," + errrorObj.error,
        "SOURCE": src
      });
    }
  }
  backupMobileVerifySuccess(src){
    clevertap.event.push(EventsNames.backupMobileVeri, {
      "ERROR": "SUCCESS",
      "SOURCE": src
    });
  }
  backupMobileVerifyError(errrorObj,src){
    if(errrorObj){
      clevertap.event.push(EventsNames.backupMobileVeri, {
        "ERROR": errrorObj.code + "," + "NA" + "," + errrorObj.error,
        "SOURCE": src
      });
    }
  }
  async fileUpload(obj,location){
    let place = await this.fetchLocation(location)
    if(place == 'ALBUM'){
      clevertap.event.push(EventsNames.fileUpload, {
        "TYPE": obj.mimeType,
        "PLACE": place,
        "Uploader": obj.isLoggedInUsrAlbumOwner ? "OWNER" : "MEMBER",
      });
    }else{
      clevertap.event.push(EventsNames.fileUpload, {
        "TYPE": obj.mimeType,
        "PLACE": place,
      });
    }
  }
  async createAlbum(albumName,place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.createAlbum, {
      "PLACE": location,
      "BOARDNAME": albumName
    });
  }
  async playAudio(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.audioPlay, {
      "PLACE": location,
    });
  }
  async fileBookmarked(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.addBookamrk, {
      "PLACE": location,
    });
  }
  async fileRemoveBookmarked(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.removeBookmark, {
      "PLACE": location,
    });
  }
  landingPageViewed(){
    clevertap.event.push(EventsNames.landingScreen,{});
  }
  landingPageViewedLoginBtnClicked(){
    clevertap.event.push(EventsNames.landingScreen,{
      "Button_clicked":"Login_button_clicked"
    });
  }
  landingPageViewedPlayStoreBtnClicked(){
    clevertap.event.push(EventsNames.landingScreen,{
      "Button_clicked":"PlayStore_button_clicked"
    });
  }
  landingPageViewedAppStoreBtnClicked(){
    clevertap.event.push(EventsNames.landingScreen,{
      "Button_clicked":"AppStore_button_clicked"
    });
  }
  landingPageScrolled(){
    clevertap.event.push(EventsNames.scroll, {
      "PLACE": "Home_Screen",
    });
  }
  loginMode(){
    clevertap.event.push(EventsNames.login, {
      "MODE": "IDAM"
    });
  }
  qrLogin(){
    clevertap.event.push(EventsNames.login, {
      //"LOGIN_TYPE": "QRSCAN" //618537 change
      "MODE" : "QR_SCAN"
    });
  }
  loginStatus(){
    clevertap.event.push(EventsNames.login, {
      "STATUS": "SUCCESS"
    });
  }
 
  googleLoginMode(){
    clevertap.event.push(EventsNames.login, {
      "MODE": "GOOGLE"
    });
  }
  facebookLoginMode(){
    clevertap.event.push(EventsNames.login, {
      "MODE": "FB"
    });
  }
  // otpLoginMode(){
  //   clevertap.event.push(EventsNames.login, {
  //     "MODE": "OTP"
  //   });
  // }
  emailLoginMode(){
    clevertap.event.push(EventsNames.login, {
      "MODE": "EMAIL"
    });
  }
  numberLoginMode(){
    clevertap.event.push(EventsNames.login, {
      "MODE": "NUMBER"
    });
  }

  screenViewedLogin(){
    clevertap.event.push(EventsNames.tabViewed, {
      "Login": 'yes'
    })
  }

  async screenViewedAllFiles(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.allFiles
    });
  }

  screenViewedVideos(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.videos
    });
  }
  screenViewedPhotos(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.Photos
    });
  }
  screenViewedAudio(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.audio
    });
  }
  screenViewedOtherFile(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.documents
    });
  }

  nonLoginHomeScreenViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.nonLoginHomeScreen
    });
  }

  nonLoginFeaturesScreenViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.nonLoginFeaturesScreen
    });
  }

  nonLoginEnterpriseScreenViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.nonLoginEnterpriseScreen
    });
  }

  
  screenViewedMyFileTrash(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.trash
    });
  }
  screenViewedMyFileBookmarks(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.myFilesFavoritesScreen
    });
  }
  screenViewedAlbumsBookmarks(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.albumFilesFavoritesScreen
    });
  }
  screenViewedAlbumFeed(){
    clevertap.event.push(EventsNames.tabViewed, {
      "BoardFeed": 'yes'
    })
  }
  screenViewedProfile(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.profile
    });
  }
  screenViewedContacts(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.contact
    });
  }
  userProfileUpdate(type){
    clevertap.event.push(EventsNames.changed, {
      "TYPE": type
    })
  }

  SPActivated(){
    clevertap.event.push(EventsNames.actionTaken,{
      "LOCATION": "Board_feed",
      "TYPE": "Thin banner",
      "ACTION_TAKEN": "Enabled"
    });
  }
  publicAlbumOpened(albumName){
    clevertap.event.push(EventsNames.publicAlbumOpened,{
      "BOARD_NAME": albumName,
    })
  }
  publicAlbumFileInfoOpened(obj,albumName){
    clevertap.event.push(EventsNames.publicAlbumFileInfoOpened,{
      "FILE_TYPE": "Audio",
      "FILE_NAME": obj.objectName,
      "BOARD_NAME":albumName,
    })
  }
  async videoPlay(location){
    let place = await this.fetchLocation(location)
    if(place == 'ALBUM'){
      place = 'ALBUMS'
    }
    clevertap.event.push(EventsNames.videoPlay,{
      "PLACE": place,
    })
  }

  mediaSeek(obj,albumName){
    clevertap.event.push(EventsNames.mediaSeek,{
      "FILE_TYPE": "Audio",
      "FILE_NAME": obj.objectName,
      "BOARD_NAME": albumName,
      "ERROR": "SUCCESS"
    })
  }

  publicAlbumMediaPlayed(obj,albumName){
    clevertap.event.push(EventsNames.publicAlbumMediaPlayed,{
      "FILE_TYPE": "Audio",
      "FILE_NAME": obj.objectName,
      "BOARD_NAME": albumName,
      "ERROR": "SUCCESS"
    })
  }
  
  publicAlbumMediaPaused(obj,albumName){
    clevertap.event.push(EventsNames.publicAlbumMediaPaused, {
      "FILE_TYPE": "Audio",
      "FILE_NAME": obj.objectName,
      "BOARD_NAME": albumName,
      "ERROR": "SUCCESS"
    });
  }
  
  commentAddedOnPublicAlbum(albumName){
    clevertap.event.push(EventsNames.commentAddedOnPublicAlbum, {
      "BOARD_NAME": albumName,
    });
  }
  inviteUsrToAlbum(totalAlbumContentCount,inviter){
    clevertap.event.push(EventsNames.albumInvite, {
      "NOOFFILES": totalAlbumContentCount,
      "INVITER": inviter,
    });
  }
  getFileCount(obj){
    this.audioCount = obj.filter(function (element, index) {
      return (element.mimeType == "audio");
    });
    this.videoCount = obj.filter(function (element, index) {
      return (element.mimeType == "video");
    });
    this.imageCount = obj.filter(function (element, index) {
      return (element.mimeType == "image");
    });
    this.otherCount = obj.filter(function (element, index) {
      return (element.mimeType != "audio" && element.mimeType != "video" && element.mimeType != "image");
    });
  }
  isAlbumOwner(ownerUserId,createdBy){
    if(ownerUserId == createdBy){
      return 'OWNER'
    }else{
      return 'MEMBER'
    }
  }
  fetchLocation(tab){
    if((tab == 'videos' ||  tab == 'docs' ||  tab == 'audio' ||  tab == 'photos' || tab == 'allfiles' || tab == 'Trash' || window.location.href.indexOf("favorites/myfiles") >1)){
      if(tab== 'allfiles' && window.location.href.indexOf("/albums") >= 0){
        return 'ALBUM'
      }else{
        return 'REPO'
      } 
    }else if(tab == 'sharedFiles') {
      return 'SHAREDFILES';
    }else if ( tab = 'Person Details'){
      return 'Faces';
    }
  }

  addManualTag(){
    clevertap.event.push(EventsNames.addManulTag, {});
  }

  saveManualTag(totalTagCount,recentTag){
    clevertap.event.push(EventsNames.albumInvite, {
      "Total Tags": totalTagCount,
      "Recent Tags": recentTag,
    });
  }

  /**
   * FOR ENHANCED SHARE - START
   */

  OnShareOptionClick() {
    clevertap.event.push(EventsNames.shareOptionClicked, {});
  }

  async onShareGetLinkClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareGetLinkClicked, {
      "PLACE": location
    });
  }

  onSharingOptionClick() {
    clevertap.event.push(EventsNames.sharingOptionClicked, {});
  }

  onSharedByMeTabClick() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.sharedByMeScreen
    });
  }

  onSharedWithMeTabClick() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.sharedWithMeScreen
    })
  }

  onSharedLinkByMeTabClick() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.sharedLinkScreen
    })
  }

  myAlbumsScreenViewed() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.myAlbumsScreen
    });
  }

  insideAlbumsScreenViewed() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.insideAlbumsScreen
    });
  }

  sharedAlbumsScreenViewed() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.sharedAlbumScreen
    });
  }

  recentFilesScreenViewed() {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.recentFilesScreen
    });
  }

  onDeleteSharedLinkClick() {
    clevertap.event.push(EventsNames.deleteSharedLinkClicked, {});
  }

  onShareAddPeopleClick() {
    clevertap.event.push(EventsNames.shareAddPeopleClicked, {});
  }

  onSharedWithLinkClick() {
    clevertap.event.push(EventsNames.sharedWithLinkClicked, {});
  }
  
  onShareViewerEditorToggleClick() {
    clevertap.event.push(EventsNames.shareViewerEditorToggleClicked, {});
  }

  onShareSendClick() {
    clevertap.event.push(EventsNames.shareSendClicked, {});
  }

  onShareCopyLinkClick() {
    clevertap.event.push(EventsNames.shareCopyLinkClicked, {});
  }

  onShareAnyoneWithLinkClick() {
    clevertap.event.push(EventsNames.shareAnyoneWithLinkClicked, {});
  }

  onShareRestrictedClick() {
    clevertap.event.push(EventsNames.shareRestrictedClicked, {});
  }

  async onShareFileInfo(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareFileInfo, {
      "PLACE": location
    });
  }

  async onShareCopyClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareCopyClicked, {
      "PLACE": location
    });
  }

  async onShareCopyHereClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareCopyHereClicked, {
      "PLACE": location
    });
  }

  async onShareCreateCopyHereClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareCreateCopyHereClicked, {
      "PLACE": location
    });
  }

  async onShareDownloadClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareDownloadClicked, {
      "PLACE": location
    });
  }

  onShareChangePermissionClick() {
    clevertap.event.push(EventsNames.shareChangePermissionClicked, {});
  }

  onShareGrantAccess() {
    clevertap.event.push(EventsNames.shareGrantAccess, {});
  }

  async onShareDeleteClick(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.shareDeleteClicked, {
      "PLACE": location
    });
  }

  onShareRequestAccess() {
    clevertap.event.push(EventsNames.shareRequestAccess, {});
  }
  /**
   * FOR ENHANCED SHARE - END
   */

  async onUserPromoStorageViewed() {
    clevertap.event.push(EventsNames.userPromoStorageViewed, {
    });
  }

  async onUserStorageClicked() {
    clevertap.event.push(EventsNames.userStorageClicked, {
    });
  }

  async passPhraseEnabled() {
    clevertap.event.push(EventsNames.passPhraseEnabled, {
    });
  }

  async passPhraseReset(location) {
    clevertap.event.push(EventsNames.passPhraseReset, {
      "SCREEN": location
    });
  }

  async forgotPassphraseClicked() {
    clevertap.event.push(EventsNames.forgotPassphraseClicked, {
    });
  }
  async passphraseScreenViewed(screen) {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "Screen":screen
    });
  }

  async plansToggle(tabType){
    clevertap.event.push(EventsNames.paidPlans, {
      "tab":tabType
    });
  }

  async visitedFAQFromPricingTab(){
    clevertap.event.push(EventsNames.faqSection, {});
  }

  async buyStorage(){
    clevertap.event.push(EventsNames.buyStoragePlans, {});
  }

  async familyShareAddUser(){
    clevertap.event.push(EventsNames.familyShareAddUser, {});
  }

  async familyShareSendInvite(errObj){
    if(errObj) {
      clevertap.event.push(EventsNames.familyShareSendInvite, {
        "ERROR": errObj.code + "," + errObj.error
      });
    } else {
      clevertap.event.push(EventsNames.familyShareSendInvite, {});
    }
    
  }

  async familyShareDelete(deleteAction){
    clevertap.event.push(EventsNames.familyShareDelete, {
      "Action":deleteAction
    });
  }

  async familyShareDeleteError(deleteAction, errObj){
    clevertap.event.push(EventsNames.familyShareDelete, {
      "Action":deleteAction,
      "ERROR": errObj.code + "," + errObj.error
    });
  }
  async familyShareLeave(){
    clevertap.event.push(EventsNames.familyShareLeave, {});
  }

  async familyShareAcceptInvite(inviteAction){
    clevertap.event.push(EventsNames.familyShareAcceptInvite, {
      "Action":inviteAction
    });
  }
  async troubleLoginTap(){
    clevertap.event.push(EventsNames.troubleLoginTap, {
      "MAPPING":"True",
      "ERROR": "SUCCESS"
    });
  }

  async troubleLoginTapError(error){
    clevertap.event.push(EventsNames.troubleLoginTap, {
      "MAPPING": "False",
      "ERROR": error
    });
  }

  async troubleLoginCustomerCareTap(){
    clevertap.event.push(EventsNames.troubleLoginCustomerCareTap, {});
  }

  async troubleLoginScreenViewed(screen) {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "Screen":screen
    });
  }

  async privateShareClick(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.privateShareClick, {
      "PLACE": location
    });
  }
  
  async publicShareLinkClick(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.publicShareLinkClick, {
      "PLACE": location
    });
  }
  
  async privateShareUserAdded(){
    clevertap.event.push(EventsNames.privateShareUserAdded, {});
  }
    
  async privateSharePermissionChanges(){
    clevertap.event.push(EventsNames.privateSharePermissionChanges, {});
  }
  
  async privateShareSave(){
    clevertap.event.push(EventsNames.privateShareSave, {});
  }
  async publicShareLinkExpiryChange(){
    clevertap.event.push(EventsNames.publicShareLinkExpiryChange, {});
  }
  async publicSharePasswordSet(){
    clevertap.event.push(EventsNames.publicSharePasswordSet, {});
  }
  async publicShareCopied(){
    clevertap.event.push(EventsNames.publicShareCopied, {});
  }
  async publicShareOpenShareFrame(){
    clevertap.event.push(EventsNames.publicShareOpenShareFrame, {});
  }
  async publicShareLinkEmailed(){
    clevertap.event.push(EventsNames.publicShareLinkEmailed, {});
  }
  async publicShareLinkSaved(){
    clevertap.event.push(EventsNames.publicShareLinkSaved, {});
  }
  async publicShareLinkPasswordEntered(){
    clevertap.event.push(EventsNames.publicShareLinkPasswordEntered, {});
  }
  async publicShareDownloadClicked(){
    clevertap.event.push(EventsNames.publicShareDownloadClicked, {});
  }
  async addtoJioCloudClicked(){
    clevertap.event.push(EventsNames.addtoJioCloudClicked, {});
  }
  async FileAddedtoJioCloud(){
    clevertap.event.push(EventsNames.FileAddedtoJioCloud, {});
  }
  jtrClick() {
    clevertap.event.push(EventsNames.jtr_clicked, {});
  }
  experienceModalOpened(){
    clevertap.event.push(EventsNames.experienceModalOpened,{
      "PROPERTY":this.experienceNowModalLocation
    })
  }
  experienceDialogInteracted(interaction){
    clevertap.event.push(EventsNames.experienceDialogInteracted,{
      "INTERACTION": interaction
    })
  }
  peopleEmailSent(){
    clevertap.event.push(EventsNames.peopleEmailSent,{
      "USER": "Whitelisted"
    })
  }
  individualFaceClicked(src){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.facesIndividual,
      "SOURCE": src
    });
  }
  removeFacesFeddbackSubmitted(selectedOption){
    clevertap.event.push(EventsNames.removeFacesFeddbackSubmitted,{
      "FEEDBAck": selectedOption
    })
  }
  faceNameEdited(status){
    clevertap.event.push(EventsNames.faceNameEdited,{
      "PROPERTY": status
    })
  }
  async addToAlbumClicked(place) {
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.addToAlbumClicked, {
      "PLACE": location
    });
  }
  async addToAlbumSuc(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.addToAlbumSuc, {
      "PLACE": location
    });
  }
  async fileDelete(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileDelete, {
      "PLACE": location
    });
  }
  async fileDownloadClicked(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileDownloadClicked, {
      "PLACE": location
    });
  }
  async fileDownloadSuc(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileDownloadSuc, {
      "PLACE": location
    });
  }
  async fileMove(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileMove, {
      "PLACE": location
    });
  }
  async fileRename(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileRename, {
      "PLACE": location
    });
  }
  async fileOpened(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileOpened, {
      "PLACE": location
    });
  }
  async fileInfoClicked(place){
    let location = await this.fetchLocation(place)
    clevertap.event.push(EventsNames.fileInfoClicked, {
      "PLACE": location
    });
  }
  downloadAppPageOpened(){
    clevertap.event.push(EventsNames.userScreenViewed,{
      "SCREEN": ScreenNames.downloadApp
    }) 
  }
  userFullBannerClicked(){
    clevertap.event.push(EventsNames.userFullBannerClicked,{
    }) 
  }
  userFullBannerClosed(){
    clevertap.event.push(EventsNames.userFullBannerClosed,{
    }) 
  }
  userFullBannerLinkClicked (){
    clevertap.event.push(EventsNames.userFullBannerLinkClicked,{
    }) 
  }

  entpriseScreenViewed(screen){
    if(screen == 'dashboard'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entDasboard
      })
    }else if(screen == 'report'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entReports
      })
    }else if (screen == 'setting'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entSettings
      })
    }else if (screen == 'manage teams'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entManageTeam
      })
    } else if (screen == 'invites pending'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entInvitesPending
      })
    } else if (screen == 'inactive users'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.entInactiveUsers
      })
    }

  }

  takeOutScreeViewed(screen){
    if(screen == 'export'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.dataExportPage
      })
    }else if(screen == 'history'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.dataExportHistory
      })
    }
  }



  exportDownload(){
    clevertap.event.push(EventsNames.exportHistoryClicked,{
      "PLACE": 'Export History'
    }) 
  }
  
  finishExportCancelOpt(text){
    clevertap.event.push(EventsNames.finishExportCancelOpt,{
      "CTA_Text": text
    })
  }

  cancelExportClicked(place){
    clevertap.event.push(EventsNames.cancelExportClicked,{
      "PLACE": place
    })
  }

  dataExportWithNoName(){
    clevertap.event.push(EventsNames.dataExportWithNoName,{
    })
  }

  dataExportWithName(){
    clevertap.event.push(EventsNames.dataExportWithName,{
    })
  }

  dataExportChunksNextBtn(){
    clevertap.event.push(EventsNames.dataExportChunksNextBtn,{
    })
  }

  dataExportfilesandFolderNextBtn(){
    clevertap.event.push(EventsNames.dataExportfilesandFolderNextBtn,{
    })
  }

  dataExportEverythingOnJiocloudNextBtn(){
    clevertap.event.push(EventsNames.dataExportEverythingOnJiocloudNextBtn,{
    })
  }

  teamFolderScreeViewed(screen){
    if(screen == 'teamFolderList'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tflisting
      })
    }else if(screen == 'teamFolderListAdmin'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tflistingConsole
      })
    }else if(screen == 'tfSettingsJioCloud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfSetting
      })
    }else if(screen == 'tfSettingsConsole'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfConsoleSett
      })
    }else if(screen == 'tfMembersJioCloud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.thMemberInfo
      })
    }else if(screen == 'tfMembersConsole'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfMemberConsoleInfo
      })
    }else if(screen == 'tfTrashJioCloud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfTrash
      })
    }else if(screen == 'tfActivityLogJioCloud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfActivityLog
      })
    }else if(screen == 'tfSharedItemsJioCLoud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfSharedItems
      })
    }else if(screen == 'tfOpen'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfOpened
      })
    }else if(screen == 'tfFolderInfoJioCloud'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfFolderInfo
      })
    }else if(screen == 'tfFolderInfoConsole'){
      clevertap.event.push(EventsNames.userScreenViewed,{
        "SCREEN": ScreenNames.tfConsoleFolderInfo
      })
    }

  }
  
  tfObjectDeleteFromTrash(){
    clevertap.event.push(EventsNames.tfObjectDeleteFromTrash,{})
  }
  tfObjectRestoreFromTrash(){
    clevertap.event.push(EventsNames.tfObjectRestoreFromTrash,{})
  }
  tfObjectDeleteFromtf(){
    clevertap.event.push(EventsNames.tfObjectDeleteFromtf,{})
  }
  tfUpload(){
    clevertap.event.push(EventsNames.tfUpload,{})
  }
  tfCopy(){
    clevertap.event.push(EventsNames.tfCopy,{})
  }
  tfCopyRepoToTf(){
    clevertap.event.push(EventsNames.tfCopyRepoToTf,{})
  }
  tfPrivateShare(){
    clevertap.event.push(EventsNames.tfPrivateShare,{})
  }
  tfPublicShare(){
    clevertap.event.push(EventsNames.tfPublicShare,{})
  }
  tfObjRename(){
    clevertap.event.push(EventsNames.tfObjRename,{})
  }
  tfObjDownload(){
    clevertap.event.push(EventsNames.tfObjDownload,{})
  }
  tfRename(){
    clevertap.event.push(EventsNames.tfRename,{})
  }
  tfRenameConsole(){
    clevertap.event.push(EventsNames.tfRenameConsole,{})
  }
  tfDesc(){
    clevertap.event.push(EventsNames.tfDesc,{})
  }
  tfDescConsole(){
    clevertap.event.push(EventsNames.tfDescConsole,{})
  }
  createTF(){
    clevertap.event.push(EventsNames.createTF,{})
  }
  addMemberToTf(){
    clevertap.event.push(EventsNames.addMemberToTf,{})
  }
  addMemberToTfConsole(){
    clevertap.event.push(EventsNames.addMemberToTfConsole,{})
  }
  deleteTfMember(){
    clevertap.event.push(EventsNames.deleteTfMember,{})
  }
  deleteTfMemberConsole(){
    clevertap.event.push(EventsNames.deleteTfMemberConsole,{})
  }
  tfMemberRoleModify(){
    clevertap.event.push(EventsNames.tfMemberRoleModify,{})
  }
  tfMemberRoleModifyConsole(){
    clevertap.event.push(EventsNames.tfMemberRoleModifyConsole,{})
  }
  tfDelete(){
    clevertap.event.push(EventsNames.tfDelete,{})
  }

  thirdPartyBackupCard(medium){
    if(medium == 'gdrive'){
      clevertap.event.push(EventsNames.thirdPartyBackupCardClicked,{
        "Medium": 'GDrive'
      })
    }else if(medium == 'gphotos'){
      clevertap.event.push(EventsNames.thirdPartyBackupCardClicked,{
        "Medium": 'GPhotos'
      })
    }else if(medium == 'dropbox'){
      clevertap.event.push(EventsNames.thirdPartyBackupCardClicked,{
        "Medium": 'DropBox'
      })
    }
  }
  thirdPartyBackupInitiated(medium){
    if(medium == 'gdrive'){
      clevertap.event.push(EventsNames.thirdPartyBackupInitiated,{
        "Medium": 'GDrive'
      })
    }else if(medium == 'gphotos'){
      clevertap.event.push(EventsNames.thirdPartyBackupInitiated,{
        "Medium": 'GPhotos'
      })
    }else if(medium == 'dropbox'){
      clevertap.event.push(EventsNames.thirdPartyBackupInitiated,{
        "Medium": 'DropBox'
      })
    }
  }

  thirdPartyBackupPaused(medium){
    if(medium == 'gdrive'){
      clevertap.event.push(EventsNames.thirdPartyBackupPaused,{
        "Medium": 'GDrive'
      })
    }else if(medium == 'gphotos'){
      clevertap.event.push(EventsNames.thirdPartyBackupPaused,{
        "Medium": 'GPhotos'
      })
    }else if(medium == 'dropbox'){
      clevertap.event.push(EventsNames.thirdPartyBackupPaused,{
        "Medium": 'DropBox'
      })
    }
  }

  thirdPartyBackupDisconnected(medium){
    if(medium == 'gdrive'){
      clevertap.event.push(EventsNames.thirdPartyBackupDisconnected,{
        "Medium": 'GDrive'
      })
    }else if(medium == 'gphotos'){
      clevertap.event.push(EventsNames.thirdPartyBackupDisconnected,{
        "Medium": 'GPhotos'
      })
    }else if(medium == 'dropbox'){
      clevertap.event.push(EventsNames.thirdPartyBackupDisconnected,{
        "Medium": 'DropBox'
      })
    }
  }

  entAddUser(){
    clevertap.event.push(EventsNames.entAddUser,{})
  }
  entCreateGroup(){
    clevertap.event.push(EventsNames.entCreateGroup,{})
  }
  entImportUserCsv(){
    clevertap.event.push(EventsNames.entImportUserCsv,{})
  }
  entDeleteUsr(){
    clevertap.event.push(EventsNames.entDeleteUsr,{})
  }
  entDisableUsr(){
    clevertap.event.push(EventsNames.entDisableUsr,{})
  }
  entResendInvite(){
    clevertap.event.push(EventsNames.entResendInvite,{})
  }
  entDeleteInvite(){
    clevertap.event.push(EventsNames.entDeleteInvite,{})
  }
  entUpdateUsrDetails(){
    clevertap.event.push(EventsNames.entUpdateUsrDetails,{})
  }
  entPublicShareSettingUpdated(){
    clevertap.event.push(EventsNames.entPublicShareSettingUpdated,{})
  }
  entPrivateShareSettingUpdated(){
    clevertap.event.push(EventsNames.entPrivateShareSettingUpdated,{})
  }
  entTeamFolderStorageUpdated(){
    clevertap.event.push(EventsNames.entTeamFolderStorageUpdated,{})
  }
  entNotificationIconClicked(){
    clevertap.event.push(EventsNames.entNotificationIconClicked,{})
  }
  entReportFilterByDate(){
    clevertap.event.push(EventsNames.entReportFilterByDate,{})
  }
  entReportFilterByUser(){
    clevertap.event.push(EventsNames.entReportFilterByUser,{})
  }
  entReportFilterByActivity(){
    clevertap.event.push(EventsNames.entReportFilterByUser,{})
  }
  entPublicShareCopyLink(){
    clevertap.event.push(EventsNames.entPublicShareCopyLink,{})
  }
  entPublicShareLinkDeleted(){
    clevertap.event.push(EventsNames.entPublicShareLinkDeleted,{})
  }
  entPublicDeleteAllShareLinks(){
    clevertap.event.push(EventsNames.entPublicDeleteAllShareLinks,{})
  }
  entPrivateShareEditAccess(){
    clevertap.event.push(EventsNames.entPrivateShareEditAccess,{})
  }
  entPrivateshareDisableAllAccess(){
    clevertap.event.push(EventsNames.entPrivateshareDisableAllAccess,{})
  }

  privateFolderScreenViewed(){
    clevertap.event.push(EventsNames.userScreenViewed,{
      "SCREEN": ScreenNames.pf
    })
  }
  pfOptClickedFromProfile(){
    clevertap.event.push(EventsNames.pfOptClickedFromProfile,{})
  }
  setUpPrivatefolderClicked(){
    clevertap.event.push(EventsNames.setUpPrivatefolderClicked,{})
  }
  deletePrivateFolder(){
    clevertap.event.push(EventsNames.deletePrivateFolder,{})
  }
  pfresetPasswordclicked(){
    clevertap.event.push(EventsNames.pfresetPasswordclicked,{})
  }
  pfCreated(){
    clevertap.event.push(EventsNames.pfCreated,{})
  }
  moveToPf(){
    clevertap.event.push(EventsNames.moveToPf,{})
  }
  pfUpload(){
    clevertap.event.push(EventsNames.pfUpload,{})
  }
  pfNewFolderCreated(){
    clevertap.event.push(EventsNames.pfNewFolderCreated,{})
  }
  moveOutOfPf(){
    clevertap.event.push(EventsNames.moveOutOfPf,{})
  }
  pfDeleteObj(){
    clevertap.event.push(EventsNames.pfDeleteObj,{})
  }
  deletePfSucc(){
    clevertap.event.push(EventsNames.deletePfSucc,{})
  }
  moveWithinPf(){
    clevertap.event.push(EventsNames.moveWithinPf,{})
  }


  // memory events
  memoryClicked(memoryId){
    clevertap.event.push(EventsNames.memoryClicked,{
      "Spotlight ID":memoryId
    })
  }
  // memoryArrowClicked(){
  //   clevertap.event.push(EventsNames.memoryArrowClicked,{})
  // }
  // memoryPause(memoryId){
  //   clevertap.event.push(EventsNames.memoryPause,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryRightSwipe(memoryId){
  //   clevertap.event.push(EventsNames.memoryRightSwipe,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryLeftSwipe(memoryId){
  //   clevertap.event.push(EventsNames.memoryLeftSwipe,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  memoryAddToAlbumClicked(memoryId,status){
    clevertap.event.push(EventsNames.memoryAddToAlbumClicked,{
      "Spotlight ID":memoryId,
      "Status":status
    })
  }
  memoryshareClicked(){
    clevertap.event.push(EventsNames.memoryshareClicked,{})
  }
  memoryMarkFavourite(memoryId){
    clevertap.event.push(EventsNames.memoryMarkFavourite,{
      "Spotlight ID":memoryId
    })
  }
  // memoryUnmarkFavourite(memoryId){
  //   clevertap.event.push(EventsNames.memoryUnmarkFavourite,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  memoryDownloadClicked(memoryId,objectKey){
    clevertap.event.push(EventsNames.memoryDownloadClicked,{
      "Spotlight ID":memoryId,
      "Object Key": objectKey,
      "Status": "Success"
    })
  }
  memoryHidePhotoClicked(memoryId){
    clevertap.event.push(EventsNames.memoryHidePhotoClicked,{
      "Spotlight ID":memoryId
    })
  }
  // memoryHidePhotoDone(memoryId){
  //   clevertap.event.push(EventsNames.memoryHidePhotoDone,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryHidePhotoCancel(memoryId){
  //   clevertap.event.push(EventsNames.memoryHidePhotoCancel,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  memoryRemoveClicked(memoryId){
    clevertap.event.push(EventsNames.memoryRemoveClicked,{
      "Spotlight ID":memoryId
    })
  }
  // memoryRemoveDone(memoryId){
  //   clevertap.event.push(EventsNames.memoryRemoveDone,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryRemoveCancel(memoryId){
  //   clevertap.event.push(EventsNames.memoryRemoveCancel,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryPreviewClose(memoryId){
  //   clevertap.event.push(EventsNames.memoryPreviewClose,{
  //     "Spotlight ID":memoryId
  //   })
  // }
  // memoryPlayPauseOnUserAction(memoryId,status){
  //   clevertap.event.push(EventsNames.memoryPlayPauseOnUserAction,{
  //     "Spotlight ID":memoryId,
  //     "Status" :status
  //   })
  // }
  
  memoryImageDownloadFailed(memoryId,objectKey){
    clevertap.event.push(EventsNames.memoryImageDownloadFailed,{
      "Spotlight ID":memoryId,
      "Object ID":objectKey
    })
  }
  peopleTabScreenViewed(screen){
    if(screen == 'faceScreen'){
      clevertap.event.push(EventsNames.userScreenViewed, {
        "SCREEN": ScreenNames.faceScreen
      });
    }else if(screen == 'peopleScreen'){
      clevertap.event.push(EventsNames.userScreenViewed, {
        "SCREEN": ScreenNames.peopleScreen
      });
    }else if(screen == 'faceGroupingConsent'){
      clevertap.event.push(EventsNames.userScreenViewed, {
        "SCREEN": ScreenNames.faceGroupingConsent
      });
    }
  }

  async homeScreenViewed(){
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.homeScreenViewed
    });
  }

  async FacesListViewed(src) {
    clevertap.event.push(EventsNames.userScreenViewed, {
      "SCREEN": ScreenNames.facesList,
      "SOURCE": src
    });
  }

  async peopleConsentPopupEvents(src) {
    clevertap.event.push(EventsNames.userPeopleConsentPopup, {
      "Option_Selected": src
    });
  }

  userPeopleClicked(){
    clevertap.event.push(EventsNames.userPeopleClicked,{})
  }
  userFaceGroupToggled(status){
    clevertap.event.push(EventsNames.userFaceGroupToggled,{
      "Status": status
    })
  }
  userPeoplePageSorting(filterType){
    let selectedOpt = filterType.split(' ').join('_');
    clevertap.event.push(EventsNames.userPeoplePageSorting,{
      "SORTING": selectedOpt
    })
  }
  userFaceNameUpdated(){
    clevertap.event.push(EventsNames.userFaceNameUpdated,{})
  }

  userFaceTagAdded(){
    clevertap.event.push(EventsNames.userFaceTagAdded,{})
  }
  userFaceResultRemoved(){
    clevertap.event.push(EventsNames.userFaceResultRemoved,{})
  }

  msOfficeClicked(medium){
    clevertap.event.push(EventsNames.msOfficeClicked,{
      "Medium": medium
    })
  }
  manageVerClicked(){
    clevertap.event.push(EventsNames.manageVerClicked,{})
  }
  manageVerDownloadClicked(){
    clevertap.event.push(EventsNames.manageVerDownloadClicked,{})
  }
  manageVerRestoreClicked(){
    clevertap.event.push(EventsNames.manageVerRestoreClicked,{})
  }
  manageVerDeleteForeverClicked(){
    clevertap.event.push(EventsNames.manageVerDeleteForeverClicked,{})
  }
  diconnectMsOffice(){
    clevertap.event.push(EventsNames.diconnectMsOffice,{})
  }
  allowMsOffice(){
    clevertap.event.push(EventsNames.allowMsOffice,{})
  }
  
  userQuotaEightyPercentFull(val){
    clevertap.event.push(EventsNames.userQuotaEightyPercentFull, {
      "Clicked_On" : val
    })
  }
  
  userQuotaHundredPercentFull(val){
    clevertap.event.push(EventsNames.userQuotaHundredPercentFull, {
      "Clicked_On" : val
    })
  }

  userPlanExpired(val){
    clevertap.event.push(EventsNames.userPlanExpired, {
      "Clicked_On" : val
    })
  }

  sortInAllFiles(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.allFiles,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }
  sortInAllFilesFolder(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.customeFolder,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }

  sortInPhotos(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.Photos,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }
  sortInVideos(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.videos,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }
  sortInAudios(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.audio,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }
  sortInDocs(sortingParameter,sortingDirection){
    clevertap.event.push(EventsNames.userSorting, {
      "Sorting_Source": ScreenNames.documents,
      "Sorting_Parameter":sortingParameter,
      "Sorting_Direction":sortingDirection
    });
  }

  userMemoryToggled(status){
    clevertap.event.push(EventsNames.userMemoryToggled,{
      "Status": status
    })
  }
  //old search
  searchInitiate(source){
    clevertap.event.push(EventsNames.searched, {
      "Source":source
    });
  }
  // searchHistoryTapped(source,type){
    // if(type=="FE"){
    //   type="File"
    // }else if(type=="FR"){
    //   type="Folder"
    // }
    // clevertap.event.push(EventsNames.searchHistoryTapped, {
    //   "Source":source,
    //   "Type":type
    // });
  // }
  

  // new search
  searchHistoryTapped(action){
    clevertap.event.push(EventsNames.searchHistoryTapped,{
      "Action": action
    })
  }
  top5FacesFromSearchSuggestionClicked(){
    clevertap.event.push(EventsNames.searchFacesTapped,{})
  }
  searchTapped(place){
    place ==  "allfiles" ? 'MyFiles' : place
    clevertap.event.push(EventsNames.searchTapped,{
      "Platform": 'Web',
      "Place":place
    })
  }
  searchQueryExecuted(suggestionUsed,status){
    clevertap.event.push(EventsNames.searchExecuted,{
      "is_suggestion_used": suggestionUsed,
      "result_displayed" :status

    })
  }
  searchResultTapped(source,type,isSearchResultUsed){
    if(type=="FE"){
      type="File"
    }else if(type=="FR"){
      type="Folder"
    }else if(type == 'location'){
      type="Location"
    }else if(type == 'date'){
      type="Date"
    }
    if(type && (type == 'videoCluster' || type == 'videos')){
      type="Videos Cluster"
    }else if (type && (type == 'photoCluster' || type == 'photos')){
      type="Photo Cluster"
    }
    clevertap.event.push(EventsNames.searchResultTapped, {
      "Source":source,
      "Type":type,
      "View All":'',
      "is_suggestion_used" :isSearchResultUsed
    });
  }

  searchResulViewAllTapped(viewAllLocation){
    clevertap.event.push(EventsNames.searchResultTapped, {
      "View All":viewAllLocation,
      "is_suggestion_used" :false
    });
  }

  searchResultPageViewed(){
    clevertap.event.push(EventsNames.screenViewed,{
      "SCREEN" : "Search Result"
    })
  }

  searchSuggestionViewed(){
    clevertap.event.push(EventsNames.screenViewed,{
      "SCREEN" : "Suggestions"
    })
  }

  eventsTapped(){
    clevertap.event.push(EventsNames.userEventsTapped,{})
  }




  
  

}


export enum ScreenNames{ //screen property values
    allFiles ="All Files",
    albums = "BoardFeed",
    profile = "Profile",
    contact = "Contacts",
    videos = "Videos",
    Photos = "Photos",
    documents = "Documents",
    photosVideos = "Photos &Videos",
    audio = "Audio",
    others = "OtherFile",
    trash = "Trash",
    albumTrash = "BoardsTrash",
    mandatoryEmailVeri = "Mandatory_Email_Verification",
    resetPassPhrase = "Reset passphrase",
    forgotPassPhrase = "Forgot passphrase",
    toubleLoigin = "Trouble_login",
    downloadApp = "JioAICloud download app",
    notMandatoryEmailVeri ="Email_Verification",
    phoneVeri = "Phone_Verification",
    backupVeri = "Backup_Phone_Verification",
    homeScreenViewed = "Home",

    nonLoginHomeScreen = "Non Login Home",
    nonLoginFeaturesScreen = "Non Login Features",
    nonLoginEnterpriseScreen = "Non Login Enterprise",

    myFilesFavoritesScreen = "Favorites My Files",
    albumFilesFavoritesScreen= "Favorites Album Files",

    myAlbumsScreen = "My Albums",
    sharedAlbumScreen = "Shared Albums",
    insideAlbumsScreen = "Inside Album",

    recentFilesScreen = "Recent Files",

    sharedByMeScreen = "Shared by me",
    sharedWithMeScreen = "Shared with me",
    sharedLinkScreen = "Shared link",

    entDasboard = "Dashboard Console",
    entReports = "Reports Console",
    entSettings = "Settings Console",
    entManageTeam = "Manage Team Console",
    entInvitesPending = "Invites Pending",
    entInactiveUsers = "Inactive Users",

    dataExportPage ="Create Export",
    dataExportHistory = "Export History",

    tflisting = "TF Listing",
    tflistingConsole = "TF Listing Console",
    tfFolderInfo = "TF Folder Info",
    tfConsoleFolderInfo = "TF Folder Info Console",
    tfSetting = "TF Settings",
    tfConsoleSett = "TF Settings Console",
    thMemberInfo = "TF Members Info",
    tfMemberConsoleInfo = "TF Members Info Console",
    tfTrash = "TF Trash",
    thTrashConsole = "TF Trash Console",
    tfActivityLog = "TF Activity Log",
    thActivityLogConsole = "TF Activity Log Console",
    tfSharedItems = "TF Shared Items",
    tfSharedItemConsole = "TF Shared Items Console",
    tfOpened = "TF Opened",
    
    pf= "Private Folder",

    faceScreen = "Face Details",
    peopleScreen = "People",
    faceGroupingConsent = "Face_Grouping_Consent",
    customeFolder = "Custom Folder",
    facesList = "Faces_List",
    facesIndividual = "Faces_Individual",

    searchResult = "Search Result",
    suggestion = "Suggestions"

}
export enum EventsNames { // clevetap events name

  fileView = "FILE_VIEWED",
  shareLink ="SHARE_LINK",
  createFolder = "CREATE_FOLDER",
  fileUpload = "FILE_UPLOAD",
  createAlbum = "CREATE_BOARD",
  audioPlay = "AUDIO_PLAY",
  addBookamrk = "FILE_BOOKMARKED",
  landingScreen = "LANDING_SCREEN_VIEWED",
  scroll = "PAGE_SCROLL",
  login = "User_App_Login",
  screenViewed = "Screen Viewed",
  logout = "USER_LOGOUT",
  userScreenViewed = "User_Screen_View",
  bannerClicked = "User_Webbanner_Clicked",
  emailVerifyOtp = "User_OTP_Request",
  emailVeri = "User_Email_Verification",
  mobileVeri =  "User_Mobile _Verification",
  backupMobileVeri = "User_BackupPhone _Verification",
  emailVerifyAlreadyHaveOtp = "User_Alreadyhaveotp_Clicked",
  removeBookmark = "FILE_BOOKMARK_REMOVED",
  otherLogin = "LOGIN_MODE",
  changed = "CHANGED",
  public_content_on = "User_PublicContent_ToggledOn",
  public_content_off = "User_PublicContent_ToggledOff",
  videoPlay = "VIDEO_PLAY",
  tabViewed = "SCREEN_VIEWED",
  SPBannerView = "User_PublicBoard_Banner_Viewed",
  actionTaken = "User_PublicBoard_Banner_ActionTaken",
  publicAlbumOpened = "User_PublicBoard_View",
  publicAlbumFileInfoOpened="User_PublicFileInfo_View",
  mediaSeek = "User_PublicMedia_Scrub",
  publicAlbumMediaPlayed ="User_PublicMedia_Played",
  publicAlbumMediaPaused = "User_PublicMedia_Paused",
  commentAddedOnPublicAlbum = "User_PublicBoard_Commented",
  albumInvite ="INVITE_TO_BOARD",
  addManulTag ="User_Add_Hashtag",
  saveManulTag ="User_Save_Hashtag",

  shareOptionClicked = "User_Share_Click", // Enhanced Share - Start
  shareGetLinkClicked = "User_Get_Link",
  sharingOptionClicked = "User_Sharingoption_Clicked",

  deleteSharedLinkClicked = "User_DeleteSharedLink_Clicked",

  shareAddPeopleClicked = "User_Addpeople_Clicked",
  sharedWithLinkClicked = "User_Sharedwith_Clicked",
  shareViewerEditorToggleClicked = "User_Viewereditortoggle_Clicked",
  shareSendClicked = "User_Send_Clicked",
  shareCopyLinkClicked = "User_Copylink_Clicked",
  shareAnyoneWithLinkClicked = "User_Anyonewithlink_Clicked",
  shareRestrictedClicked = "User_Restricted_Clicked",
  shareFileInfo = "User_Fileinfo_Clicked",
  shareCopyClicked = "User_Copy_Clicked",
  shareCopyHereClicked = "User_Copyhere_Clicked",
  shareCreateCopyHereClicked = "User_Createandcopyhere_Clicked",
  shareDownloadClicked = "User_Download_Clicked",
  shareChangePermissionClicked = "User_Changepermission_Clicked",
  shareGrantAccess = "User_Grantaccess_Clicked",
  shareDeleteClicked = "User_Delete_Clicked",
  shareRequestAccess = "User_Requestaccess_Clicked",
  userPromoStorageViewed = "User_Promotional_Storage_Details_Viewed",
  userStorageClicked = "User_Storage_Clicked",
  passPhraseEnabled = "User_Passphrase_Enabled",
  passPhraseReset = "User_Passphrase_Reset",
  forgotPassphraseClicked = "User_Forgot_Passphrase_Clicked",
  paidPlans = "Plans_Tabs_Clicked",
  buyStoragePlans = "User_Pricing_Buy_Storage_Clicked",
  faqSection = "User_Pricing_FAQ_Section_Clicked",
  familyShareAddUser = "User_FamilyShare_AddClick",
  familyShareSendInvite = "User_FamilyShare_SendInvite",
  familyShareDelete = "User_FamilyShare_Delete",
  familyShareLeave = "User_FamilyShare_Leave",
  familyShareAcceptInvite = "User_FamilyShare_AcceptInvite",
  troubleLoginTap = "User_Login_TroubleLogin_Tap",
  troubleLoginCustomerCareTap = "User_CustomerCare_TAP",

  privateShareClick = "User_PrivateShare_Clicks",
  publicShareLinkClick = "User_ShareLink_Clicks",
  privateShareUserAdded = "User_Addpeople_Privateshare",
  privateSharePermissionChanges = "User_Share_Permissionchanged",
  privateShareSave = "User_PrivateShare_Saved",
  publicShareLinkExpiryChange = "User_LinkExpiry_Chnaged",
  publicSharePasswordSet = "User_LinkPassword_Set",
  publicShareCopied = "User_PublicLink_Copied",
  publicShareOpenShareFrame = "User_ShareFrame_Open",
  publicShareLinkEmailed = "User_ShareLink_Emailed",
  publicShareLinkSaved = "User_PublicShare_Saved",
  publicShareLinkPasswordEntered = "User_LinkPassword_Entered",   
  publicShareDownloadClicked = "User_Download_Clicked",
  addtoJioCloudClicked = "User_AddtoJioCloud_Clicked",
  FileAddedtoJioCloud = "User_File_AddtoJioCloud",
  jtr_clicked = "User_JTROption_Clicked",
  experienceModalOpened = "User_People_Experience_Dialog_Opened",
  experienceDialogInteracted= "User_People_Experience_Dialog_Interacted",
  peopleEmailSent ="System_Email_Sent_People_Feature",
  removeFacesFeddbackSubmitted = "User_Faces_Remove_Results_Feedback_Submitted",
  faceNameEdited = "User_Faces_Name_Clicked",
  addToAlbumClicked = 'User_File_AddToBoard',
  addToAlbumSuc = 'User_File_AddToBoard_S',
  fileDelete = "User_File_Delete",
  fileDownloadClicked = "User_File_Download",
  fileDownloadSuc = "User_File_Download_S",
  fileMove = "User_File_Move",
  fileRename = "User_File_Rename",
  fileOpened = "User_File_View",
  fileInfoClicked= "User_Fileinfo_Clicked",

  userFullBannerClicked ="User_Fullbanner_Clicked",
  userFullBannerClosed ="User_Fullbanner_Closed",
  userFullBannerLinkClicked ="User_Fullbanner_Link",

  createExportClicked = "User_DataExport_CreateExport_Clicked",
  exportHistoryClicked = "User_DataExport_ViewHistory_Clicked",
  exportDownload = "User_DataExport_DownloadZip_Clicked",
  finishExportCancelOpt = "User_DataExport_FinishExport_CancelExport_Clicked",
  cancelExportClicked = "User_DataExport_CancelExport_Clicked",
  dataExportWithNoName = "User_DataExport_ExportName_FinishExport_BlankName_Clicked",
  dataExportWithName = "User_DataExport_ExportName_FinishExport_CustomName_Clicked",
  dataExportChunksNextBtn = "User_DataExport_SelectData_ChunkSize_Next_Clicked",
  dataExportfilesandFolderNextBtn  = "User_DataExport_SelectData_SelectiveData_Next_Clicked",
  dataExportEverythingOnJiocloudNextBtn = "User_DataExport_SelectData_Everything_Next_Clicked",

  tfObjectDeleteFromTrash = "User_TF_Trash_Object_Delete_Success",
  tfObjectRestoreFromTrash= "User_TF_Trash_Object_Restore_Success",
  tfUpload = "User_TF_Object_Upload_Success",
  tfObjectDeleteFromtf ="ser_TF_Object_Delete_Success",
  tfCopy = "ser_TF_Repo_Object_Copy_Success",
  tfCopyRepoToTf = "User_TF_Repo_Object_Copy_Success",
  tfPrivateShare = "User_TF_Object_Private_Share_Success",
  tfPublicShare = "User_TF_Object_Public_Share_Success",
  tfObjRename = "User_TF_Object_Rename_Success",
  tfObjDownload  = "User_TF_Object_Download_Clicked",
  tfRename = "User_TF_Update_Name_Success",
  tfRenameConsole = "User_TF_Update_Name_Console_Success",
  tfDesc = "User_TF_Update_Description_Success",
  tfDescConsole = "User_TF_Update_Description_Console_Success",
  createTF = "User_TF_Create_TF_Success",
  addMemberToTf = "User_TF_Add_Member_Success",
  addMemberToTfConsole = "User_TF_Add_Member_Console_Success",
  deleteTfMember ="User_TF_Delete_Member_Success",
  deleteTfMemberConsole = "User_TF_Delete_Member_Console_Success",
  tfMemberRoleModify ="User_TF_Member_Role_Modify_Success",
  tfMemberRoleModifyConsole ="User_TF_Member_Role_Modify_Console_Success",
  tfDelete = "User_TF_Delete_TF_Success",
  tfPublicShareSettingUpdate ="User_TF_Settings_Public_Share_Modify_Success",
  tfPublicShareSettingUpdateConsole= "User_TF_Settings_Public_Share_Modify_Console_Success",
  tfPrivateShareSettingUpdate ="User_TF_Settings_Private_Share_Modify_Success",
  tfPrivateShareSettingUpdateConsole ="User_TF_Settings_Private_Share_Modify_Console_Success",

  thirdPartyBackupCardClicked = "User_ThirdPartyBackup_Card_Clicked",
  thirdPartyBackupInitiated = "User_ThirdPartyBackup_Backup_Initiated",
  thirdPartyBackupPaused="User_ThirdPartyBackup_Backup_Paused",
  thirdPartyBackupDisconnected = "User_ThirdPartyBackup_Backup_Disconnected",

  entAddUser = "User_ManageTeam_Add_User_Success",
  entCreateGroup = "User_ManageTeam_Create_Group_Success",
  entImportUserCsv = "User_ManageTeam_Import_Users_Success",
  entDeleteUsr= "User_ManageTeam_Delete_User_Success",
  entDisableUsr = "User_ManageTeam_Disable_User_Success",
  entResendInvite = "User_ManageTeam_Resend_Invite_Success",
  entDeleteInvite = "User_ManageTeam_Delete_Invite_Success",
  entUpdateUsrDetails ="User_ManageTeam_Update_UserDetails_Success",
  entPublicShareSettingUpdated="User_Settings_Public_Share_Modify_Success",
  entPrivateShareSettingUpdated = "User_Settings_Private_Share_Modify_Success",
  entTeamFolderStorageUpdated ="User_Settings_TF_Storage_Modify_Success",
  entNotificationIconClicked ="User_Notiifications_Clicked",
  entReportFilterByDate ="User_Reports_FilterBy_Date_Success",
  entReportFilterByUser = "User_Reports_FilterBy_User_Success",
  entReportFilterByActivity = "User_Reports_FilterBy_Activity_Success",
  entPublicShareCopyLink ="User_Reports_Public_Share_Copy_Link_Success",
  entPublicShareLinkDeleted ="User_Reports_Public_Share_DeleteLink_Success",
  entPublicDeleteAllShareLinks = "User_Reports_Public_Share_Delete_All_Links_Success",
  entPrivateShareEditAccess ="User_Reports_Private_Share_Edit_Access_Success",
  entPrivateshareDisableAllAccess = "User_Reports_Private_Share_Disable_All_Access_Success",

  pfOptClickedFromProfile ="User_PrivateFolder_Settings_Clicked",
  setUpPrivatefolderClicked = "User_PrivateFolder_SetupPF_Clicked",
  pfresetPasswordclicked = "User_PrivateFolder_ResetPassword_Clicked",
  deletePrivateFolder ="User_PrivateFolder_DeleteFolder_Clicked",
  pfCreated ="User_PrivateFolder_Created_Success",
  moveToPf = "User_MovetoPrivateFolder_Clicked",
  pfUpload="User_PrivateFolder_UploadObject_Success",
  pfNewFolderCreated ="User_PrivateFolder_CreateNewFolder_Success",
  moveOutOfPf = "User_MoveoutofPrivateFolder_Clicked",
  pfDeleteObj = "User_PrivateFolder_DeleteObject_Success",
  deletePfSucc = "User_PrivateFolder_DeletePF_Success",
  moveWithinPf = "User_MovewithinPrivateFolder_Clicked",

  memoryClicked = "User_SpotlightBanner_Clicked",
  memoryAddToAlbumClicked = "User_SpotlightAlbums_Clicked",
  memoryshareClicked = "User_SpotlightShare_Clicked",
  memoryMarkFavourite = "User_SpotlightFavourite_Marked",
  memoryDownloadClicked = "User_SpotlightDownload_Clicked",
  memoryHidePhotoClicked = "User_SpotlightHidePhoto_Clicked",
  memoryRemoveClicked = "User_SpotlightRemove_Clicked",
  memoryImageDownloadFailed = "User_SpotlightImage_Failure",

  userFaceGroupToggled ="User_FaceGroup_Toggled",
  userPeoplePageSorting  = "User_PeoplePage_Sorting",
  userFaceNameUpdated  = "User_FaceName_Updated",
  userPeopleClicked  = "User_People_Clicked",
  userFaceTagAdded  = "User_Face_Tag_Added",
  userFaceResultRemoved = "User_Face_Result_Removed",

  msOfficeClicked = "User_MSOffice_Clicked",
  manageVerClicked = "User_ManageVersions_Clicked",
  manageVerDownloadClicked = "User_ManageVersions_DownloadVersion_Clicked",
  manageVerRestoreClicked ="User_ManageVersions_RestoreVersion_Clicked",
  manageVerDeleteForeverClicked = "User_ManageVersions_DeleteForever_Clicked",
  diconnectMsOffice = "User_MyApps_Disconnect_MSOffice_Clicked",
  allowMsOffice = "User_Connect_MSOffice_Allowed",
  userQuotaEightyPercentFull = "User_Quota_EightyPercent_Full",
  userQuotaHundredPercentFull = "User_Quota_HundredPercent_Full",
  userPlanExpired = "User_Plan_Expired",

  userSorting="User_Sorting",

  userMemoryToggled ="User_Spotlight_Status",
  userPeopleConsentPopup = "User_People_Consent_Popup",


  searched = "User_Object_Searched",
  searchHistoryTapped = "User_SearchHistory_Tapped",
  searchResultTapped = "User_SearchResult_Tapped",

  searchTapped = "User_Search_Tapped",
  searchExecuted = "User_Search_Executed",
  searchFacesTapped = "User_Search_Faces_Clicked",
  userEventsTapped = "User_Events_Tapped"

}




// removed Events
// removeFacesClicked = "User_Faces_Remove_Results_Clicked",
//  memoryArrowClicked = "User_SpotlightBanner_Swipe",
// memoryPause ="User_Spotlight_SmallTap",
// memoryRightSwipe ="User_Spotlight_SwipeRight",
// memoryLeftSwipe ="User_Spotlight_SwipeLeft",
// memoryUnmarkFavourite ="User_SpotlightFavourite_Unmarked",
// memoryHidePhotoDone = "User_SpotlightHidePhoto_Done",
// memoryHidePhotoCancel = "User_SpotlightHidePhoto_Cancel",
// memoryRemoveDone = "User_SpotlightRemove_Done",
// memoryRemoveCancel = "User_SpotlightRemove_Cancel",
// memoryPreviewClose ="User_SpotlightClosed_Clicked",
// memoryPlayPauseOnUserAction = "User_SpotlightPlay_Clicked"
